/** Help: the keyboard shortcuts, behind the sidebar's Help item. */
import { Dialog, Kbd, modKey } from "../kit";
import { PICK_KEYS } from "./pick/shortcut";

const SHORTCUTS: ReadonlyArray<readonly [what: string, keys: readonly string[]]> = [
  ["Search and commands", [modKey("K")]],
  ["Next and previous person", ["J", "K"]],
  ["Mark reviewed", ["R"]],
  ["Undo", [modKey("Z")]],
  ["Point and comment", PICK_KEYS],
  ["Close a panel", ["Esc"]],
];

export function Help({ open, onClose }: { open: boolean; onClose: () => void }) {
  return (
    <Dialog open={open} onClose={onClose} title="Keyboard shortcuts">
      <dl className="flex flex-col gap-3">
        {SHORTCUTS.map(([what, keys]) => (
          <div key={what} className="flex items-center justify-between gap-4 text-body leading-none">
            <dt className="text-secondary-foreground">{what}</dt>
            <dd className="flex items-center gap-1">
              {keys.map((key) => (
                <Kbd key={key}>{key}</Kbd>
              ))}
            </dd>
          </div>
        ))}
      </dl>
    </Dialog>
  );
}
